// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class BlockContainer extends Component {
  state = {}

  static propTypes = {
    classes: PropTypes.object,
    topText: PropTypes.string,
    bottom: PropTypes.any,
  };

  static defaultProps = {
    classes: {},
    topText: 'no text',
    bottom: null,
  };

  render() {
    const { classes, topText, bottom } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <p className={classes.headerText}>{topText}</p>
        </div>
        <div className={classes.bottomContainer}>
          {bottom}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BlockContainer);
